import { memoizedCatalogData } from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import CourseProgress from 'bundles/catalogP/models/courseProgress';

export type CourseProgressOptions = {
  id: string;
  fields: string[];
};

export type CourseProgressMemoizeOptions = {
  forceUpdate?: boolean;
};

export default function (options: CourseProgressOptions, memoizeOptions?: CourseProgressMemoizeOptions) {
  if (memoizeOptions && memoizeOptions.forceUpdate) {
    return memoizedCatalogData.force(catalogUrl.build(CourseProgress.prototype.resourceName, options));
  } else {
    return memoizedCatalogData(catalogUrl.build(CourseProgress.prototype.resourceName, options));
  }
}
